import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { selectActiveCompanyId } from "../../../redux/features/user/selectors/userState.selectors";
import { getEventDeliveryLogs } from "../actions/getEventDeliveryLogs";
import { IGetEventDeliveryLogsParams } from "../interfaces";

export const EVENT_DELIVERY_LOGS_QUERY_KEY = "event-delivery-logs";

export const useGetEventDeliveryLogs = (params: IGetEventDeliveryLogsParams, enabled = true) => {
  const companyId = useSelector(selectActiveCompanyId);

  return useQuery({
    queryKey: [EVENT_DELIVERY_LOGS_QUERY_KEY, companyId, params.page, params.pageSize, params.source],
    queryFn: () => getEventDeliveryLogs(params),
    enabled: Boolean(companyId) && enabled,
  });
};
